// This file handles font loading with proper font-display strategy
// We'll create font-face rules using JavaScript which will be injected into the document

// Create a style element to contain our font-face definitions
const createFontStyles = () => {
  // Get public URL from environment or default to empty string for relative paths
  const publicUrl = process.env.PUBLIC_URL || '';
  
  // Create a new style element
  const style = document.createElement('style');
  
  // Set the font-face rules with absolute paths
  style.textContent = `
    @font-face {
      font-family: "HKGroteskPro";
      font-weight: 300;
      src: url("${publicUrl}/lk/assets/fonts/HK Grotesk Pro/HKGroteskPro-Light.woff2") format("woff2"),
           url("${publicUrl}/lk/assets/fonts/HK Grotesk Pro/HKGroteskPro-Light.woff") format("woff");
      font-display: swap;
    }

    @font-face {
      font-family: "HKGroteskPro";
      font-weight: 400;
      src: url("${publicUrl}/lk/assets/fonts/HK Grotesk Pro/HKGroteskPro-Regular.woff2") format("woff2"),
           url("${publicUrl}/lk/assets/fonts/HK Grotesk Pro/HKGroteskPro-Regular.woff") format("woff");
      font-display: swap;
    }

    @font-face {
      font-family: "HKGroteskPro";
      font-weight: 500;
      src: url("${publicUrl}/lk/assets/fonts/HK Grotesk Pro/HKGroteskPro-Medium.woff2") format("woff2"),
           url("${publicUrl}/lk/assets/fonts/HK Grotesk Pro/HKGroteskPro-Medium.woff") format("woff");
      font-display: swap;
    }

    @font-face {
      font-family: "HKGroteskPro";
      font-weight: 600;
      src: url("${publicUrl}/lk/assets/fonts/HK Grotesk Pro/HKGroteskPro-SemiBold.woff2") format("woff2"),
           url("${publicUrl}/lk/assets/fonts/HK Grotesk Pro/HKGroteskPro-SemiBold.woff") format("woff");
      font-display: swap;
    }

    @font-face {
      font-family: "HKGroteskPro";
      font-weight: 700;
      src: url("${publicUrl}/lk/assets/fonts/HK Grotesk Pro/HKGroteskPro-Bold.woff2") format("woff2"),
           url("${publicUrl}/lk/assets/fonts/HK Grotesk Pro/HKGroteskPro-Bold.woff") format("woff");
      font-display: swap;
    }
  `;
  
  // Append the style element to the head
  document.head.appendChild(style);
};

// Initialize font loading
const initFonts = () => {
  // Apply the font styles
  createFontStyles();
  
  // Set fallback font stack to ensure text is visible during font loading
  if (document.body) {
    document.body.style.fontFamily = 
      "HKGroteskPro, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";
  }
};

export default initFonts; 